import { store } from '@/stores'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Register, RouterProvider } from '@tanstack/react-router'
import { Provider as JotaiProvider } from 'jotai'

type AppProps = {
  queryClient: QueryClient
  router: Register['router']
}

export default function App({ queryClient, router }: AppProps) {
  return (
    <JotaiProvider store={store}>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} context={{}} />
      </QueryClientProvider>
    </JotaiProvider>
  )
}
